import React from 'react';
import {
  Button, Input, Spin, List,
  message, Icon,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import BackgroundColorContainer from '../components/other/BackgroundColorContainer';
import theme from '../../../theme';
import {
  Box, Flex, ShowIf, Text,
} from '../../shared/components';
import GiotalkHeader from '../components/other/GiotalkHeader';
import TwoColumnsFlexLayout from '../../shared/components/layout/TwoColumnsFlex.layout';
import { crearChat, insertarUsuariosEnChat } from '../../../state/actions/creators/giotalk.actioncreator';
import { chatSeleccionadoSelector } from '../../../state/selectors/giotalk.selectors';
import { handleSagaStatus, obtenerEstadoRequestDesdeSaga } from '../../../helpers/sagaStatus.helper';


const debounce = (callback, time = 250) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(...args), time);
  };
};

class GiotalkChatCreadorPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      chatName: '',
      usuariosSeleccionados: {},
      usuariosFiltered: [],
      searchString: '',
    };
  }

  selecccionarUsuario({ usuario }) {
    const { id } = usuario;
    const { usuariosSeleccionados } = this.state;
    const usuariosSeleccionadosCopy = {
      ...usuariosSeleccionados,
    };
    if (usuariosSeleccionadosCopy[id] === undefined) usuariosSeleccionadosCopy[id] = usuario;
    else delete usuariosSeleccionadosCopy[id];

    this.setState({
      usuariosSeleccionados: usuariosSeleccionadosCopy,
    });
  }

  usuarioConCheckbox(usuario) {
    const { usuariosSeleccionados } = this.state;
    const { id, nombreCompleto, tienda } = usuario;
    const { nombre: nombreTienda } = tienda || { tienda: { nombre: '' } };
    const usuarioSeleccionado = usuariosSeleccionados[id];
    const checked = usuarioSeleccionado;
    return (
      <TwoColumnsFlexLayout
        style={{ background: '#063340' }}
        p="16"
        leftColumnStyle={{ maxWidth: '24px' }}
        leftContent={(
          <input
            type="checkbox"
            onChange={() => this.selecccionarUsuario({ usuario })}
            checked={checked}
          />
        )}
        rightContent={(
          <Box onClick={() => this.selecccionarUsuario({ usuario })} style={{ cursor: 'pointer' }}>
            <Text color="white" display="block">{nombreCompleto}</Text>
            <Text mt="8" fontSize="12" color="white">{nombreTienda}</Text>
          </Box>
        )}
      />
    );
  }

  guardarCambios() {
    const { usuariosSeleccionados, chatName } = this.state;
    const { chatSeleccionado } = this.props;
    if (chatSeleccionado === undefined) {
      const { crearChat } = this.props;
      const nombreDeChatEstaVacio = chatName.replace(/\s/g, '').length === 0;
      const usuariosSeleccionadosKeys = Object.keys(usuariosSeleccionados);
      if (usuariosSeleccionadosKeys.length > 1 && nombreDeChatEstaVacio) {
        message.error('El nombre del chat no puede estar vacío');
      } else {
        const nombreChat = (nombreDeChatEstaVacio) ? usuariosSeleccionados[usuariosSeleccionadosKeys.pop()].nombreCompleto : chatName;
        crearChat({ name: nombreChat, usuarios: usuariosSeleccionados });
      }
    } else {
      const { history, insertarUsuariosEnChat } = this.props;
      const { id: chatId } = chatSeleccionado;
      insertarUsuariosEnChat({ usuarios: usuariosSeleccionados, chatId });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { chatSeleccionado, history } = this.props;
    const { creatingRequestState: previousCreatingRequestState } = prevProps;
    const { creatingRequestState } = this.props;
    if (chatSeleccionado !== undefined) {
      const { chatCreadoId } = chatSeleccionado;
      handleSagaStatus({
        estadoPeticion: creatingRequestState,
        previousEstadoPeticion: previousCreatingRequestState,
        onWasRunningAndHasSucceded: () => {
          history.replace('/talk');
          history.replace(`/talk/chats/${chatCreadoId}/mostrar`);
        },
        onWasRunningAndHasFailed: () => {
          message.error('Ha ocurrido un error al intentar crear el chat');
        },
      });
    } else {
      handleSagaStatus({
        estadoPeticion: creatingRequestState,
        previousEstadoPeticion: previousCreatingRequestState,
        onWasRunningAndHasSucceded: () => {
          history.goBack();
        },
      });
    }
  }

  filtrarUsuarios = debounce((text) => {
    const usuariosFiltered = this.usuarios().filter((usuario) => {
      const { nombreCompleto } = usuario;
      const nombreTolower = nombreCompleto.toLowerCase();
      const textToLower = text.toLowerCase();
      return nombreTolower.includes(textToLower);
    });
    this.setState({ usuariosFiltered, searchString: text });
  }, 300);

  usuarios() {
    const { usuarios: usuariosFromDB, chatSeleccionado, usuarioId } = this.props;
    const { usuariosFiltered, searchString } = this.state;
    const usuarios = (searchString.length > 0) ? usuariosFiltered : usuariosFromDB;
    const modoEdicion = chatSeleccionado !== undefined;
    if (modoEdicion) {
      const { usuarios: usuariosFromChat } = chatSeleccionado;
      const usuariosIds = [];
      usuariosFromChat.forEach((usuario) => {
        const { intUser } = usuario;
        usuariosIds.push(intUser);
      });
      return usuarios.filter((usuario) => {
        const { id, inactivo} = usuario;
        return !usuariosIds.includes(id) && inactivo !== true;
      });
    }
    const usuariosWithoutDuplicates = [];
    const idsLoaded = [];
    for (let index = 0; index < usuarios.length; index++) {
      const usuario = usuarios[index];
      const { inactivo } = usuario;
      const { id } = usuario;
      if (idsLoaded.indexOf(id) === -1 && id != usuarioId && inactivo !== true) {
        usuariosWithoutDuplicates.push(usuario);
        idsLoaded.push(id);
      }
    }
    return usuariosWithoutDuplicates;
  }

  render() {
    const { history, chatSeleccionado } = this.props;
    const { usuariosSeleccionados } = this.state;
    const { colors: { legacyPrimary } } = theme;
    const { chatName } = this.state;
    const { creatingRequestState, estadoPeticionInsertarUsuarios } = this.props;
    const { running: runningCreatingRequest } = creatingRequestState;
    const { running: runningInsertRequest } = estadoPeticionInsertarUsuarios;

    const modoEdicion = chatSeleccionado !== undefined;

    const { nombre: title } = chatSeleccionado || { nombre: 'Nuevo grupo ' };

    const Footer = (
      <Box p="16">
        <Box style={{ borderTop: '1px solid #1d586f' }} mt="16" pt="16">
          <Flex justifyContent="space-between">
            <Box />
            <Box>
              <Box display="inline-block" mr="8">
                <Button onClick={() => history.goBack()}>Cancelar</Button>
              </Box>
              <Box display="inline-block">
                <Button
                  type="primary"
                  onClick={() => this.guardarCambios()}
                  disabled={Object.keys(usuariosSeleccionados).length === 0}
                >
                  Guardar
                </Button>
              </Box>
            </Box>
          </Flex>
        </Box>
      </Box>
    );

    return (
      <BackgroundColorContainer color={legacyPrimary}>
        <ShowIf condition={runningCreatingRequest !== true && runningInsertRequest !== true}>
          <Box position="fixed" width="100%" top="0" py="16" bg={legacyPrimary} style={{ zIndex: 100 }}>
            <Box px="16">
              <Box pb="16">
                <Input
                  placeholder="Buscar usuarios..."
                  suffix={
                    <FontAwesomeIcon icon={faSearch} />
                  }
                  onChange={e => this.filtrarUsuarios(e.target.value)}
                />
              </Box>
              <GiotalkHeader
                onBackButtonPressed={() => history.goBack()}
                title={(
                  <Box>
                    <ShowIf condition={modoEdicion === true}>
                      Añadir participantes
                    </ShowIf>
                    <ShowIf condition={modoEdicion === false}>
                      {title}
                    </ShowIf>
                  </Box>
                )}
                subtitle={(
                  <Box>
                    <ShowIf condition={modoEdicion === true}>
                      <Text
                        style={{
                          maxWidth: '100%',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                        fontSize="12"
                        color="lightgrey"
                      >
                        {title}
                      </Text>
                    </ShowIf>
                    <ShowIf condition={modoEdicion === false}>
                      <Box>
                        <Text color="white" mb="8">Nombre del chat</Text>
                        <Input
                          block
                          value={chatName}
                          onChange={e => this.setState({ chatName: e.target.value })}
                        />
                      </Box>
                    </ShowIf>
                  </Box>
                )}
              />
            </Box>
          </Box>

          <Box style={{ paddingTop: '180px', paddingBottom: '64px' }}>
            <List
              dataSource={this.usuarios()}
              renderItem={usuario => (
                this.usuarioConCheckbox(usuario)
              )}
            />
          </Box>

          <Box position="fixed" width="100%" bottom="0" backgroundColor="#063340">
            {Footer}
          </Box>
        </ShowIf>
        <ShowIf condition={runningCreatingRequest === true}>
          <Box pt="64">
            <Text fontSize="16" textAlign="center" display="block" color="white" pb="16">Creando chat</Text>
            <Spin
              style={{ margin: 'auto auto', display: 'block', color: 'white' }}
              indicator={
                <Icon type="loading" style={{ fontSize: 32 }} spin />
              }
            />
          </Box>
        </ShowIf>
        <ShowIf condition={runningInsertRequest === true}>
          <Box pt="64">
            <Text fontSize="16" textAlign="center" display="block" color="white" pb="16">Añadiendo usuarios</Text>
            <Spin
              style={{ margin: 'auto auto', display: 'block', color: 'white' }}
              indicator={
                <Icon type="loading" style={{ fontSize: 32 }} spin />
              }
            />
          </Box>
        </ShowIf>
      </BackgroundColorContainer>
    );
  }
}

const mapStateToProps = (state) => {
  const { sagas, core, giotalk } = state;
  const { auth: { user } } = state;
  const { user_info: { usuario_id: usuarioId } } = user || { user_info: { usuarioId: undefined } };
  const { usuarios } = core;
  const { chatCreadoId } = giotalk;

  return {
    chatSeleccionado: chatSeleccionadoSelector(state),
    usuarios,
    usuarioId,
    chatCreadoId,
    creatingRequestState: obtenerEstadoRequestDesdeSaga(sagas, 'GIOTALK_CHATS_CREAR'),
    estadoPeticionInsertarUsuarios: obtenerEstadoRequestDesdeSaga(sagas, 'GIOTALK_INSERTAR_USUARIOS'),
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    crearChat,
    insertarUsuariosEnChat,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiotalkChatCreadorPage);
